import { useTranslation } from 'react-i18next';

// SakerX trust band (Split Studio reverse diptych) — replaces the AIP utility /
// token-teaser band the reskin removed. Honest copy only: product properties and
// compliance-first positioning, no metrics, no native-token narrative (single
// USDT collateral). Lead statement (left) + three standards pillars (right).
// tk/bk = i18n keys, tf/bf = English fallback text (rendered when a locale
// JSON lacks the key — English-first per SakerX beta).
const PILLARS: { tk: string; bk: string; tf: string; bf: string }[] = [
  {
    tk: 'trust-1-title',
    bk: 'trust-1-body',
    tf: 'Compliance-first by design',
    bf: 'A UAE-focused venue structured for regulatory oversight from the start.',
  },
  {
    tk: 'trust-2-title',
    bk: 'trust-2-body',
    tf: 'Settled on-chain in USDT',
    bf: 'Every outcome resolves transparently on-chain. Your funds are never held in custody.',
  },
  {
    tk: 'trust-3-title',
    bk: 'trust-3-body',
    tf: 'Oracle-resolved outcomes',
    bf: 'Markets settle against verifiable data — not discretion.',
  },
];

export const TrustBand = () => {
  const { t } = useTranslation(['home']);

  return (
    <section className="saker-trust" aria-label={t('trust-eyebrow', 'Why SakerX')}>
      <div className="saker-trust-lead">
        <p className="saker-trust-eyebrow">{t('trust-eyebrow', 'Why SakerX')}</p>
        <h2 className="saker-trust-title">{t('trust-title', 'Built for a regulated market.')}</h2>
        <p className="saker-trust-lede">
          {t(
            'trust-lede',
            'SakerX brings prediction markets to the UAE with oversight, transparency, and on-chain settlement at the core.'
          )}
        </p>
      </div>
      <div className="saker-pillars">
        {PILLARS.map((p, i) => (
          <div key={p.tk} className="saker-pillar">
            <div className="saker-pillar-no">{String(i + 1).padStart(2, '0')}</div>
            <div>
              <h3 className="saker-pillar-h">{t(p.tk, p.tf)}</h3>
              <p className="saker-pillar-b">{t(p.bk, p.bf)}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
